import { createContext } from 'react';
import type { HostWorkspace } from '@/api/hostWorkspace/hostWorkspaceApi.types';

export interface HostWorkspaceContextValue {
  hostWorkspace: HostWorkspace | null;
}

export const HostWorkspaceContext = createContext<HostWorkspaceContextValue>({
  hostWorkspace: null,
});
